import { AxiosResponse } from 'axios';
import { CookieManager } from "@Utilities/CookieManager";
import { TextResource } from "@Utilities/TextResource";
import { Validation } from "@Validation/Validation";
import { EngagementProvider } from "./Engagement";
import { Tenant } from "@Utilities/Tenant";
import { DataPrivacyPolicy } from "@Utilities/DataPrivacyPolicy";
import { SubscriptionService } from '@Api/SubscriptionService';

export class SubscriptionBase
{
	private readonly dataPrivacyPolicy: DataPrivacyPolicy;
	private readonly engagementProvider: EngagementProvider;

	constructor()
	{
		this.dataPrivacyPolicy = new DataPrivacyPolicy();
		this.engagementProvider = new EngagementProvider();
	}

	private MaskPhoneInput = (form: HTMLFormElement): void =>
	{
		if (form.getAttribute("data-show-phone") !== null && form.getAttribute("data-show-phone") === "true")
		{
			const phoneCheck: HTMLInputElement = form.querySelector("#chkPhone");
			const phoneCollapse: HTMLElement = form.querySelector("#collapsePhone");
			const phoneInput = document.getElementById("txtPhone");
			let maskFormat = "000-000-0000";

			if (Tenant.DomainProjectID == Tenant.ID.HalloweenCostumesAU)
			{
				maskFormat = "0000 000 000";
			}

			if (phoneInput !== null)
			{
				phoneInput.addEventListener("focusin", () =>
				{
					import("imask")
						.then((IMask) =>
						{
							const phoneMask = new IMask.InputMask(phoneInput, {
								mask: maskFormat
							});
						});
				}, { once: true });

				if (phoneCheck !== null && phoneCollapse !== null)
				{
					phoneCheck.addEventListener("change", () =>
					{
						if (phoneCollapse.style.display === "none")
						{
							phoneCollapse.style.display = "block";
						}
						else
						{
							phoneCollapse.style.display = "none";
						}
					});
				}
			}
		}
	};

	public get GenericText(): string
	{
		return "";
	}

	public get GenericThanks(): string
	{
		return "";
	}

	public ConfigureForm = (form: HTMLFormElement): void =>
	{
		if (form !== null)
		{
			this.MaskPhoneInput(form);
			this.CheckExclusions(form);
		}
	};

	public CheckExclusions = (form: HTMLFormElement): void =>
	{
		const returnVisitorCookie = CookieManager.Cookies.ReturnVisitor;
		const hasOrdered = (CookieManager.GetCookie(returnVisitorCookie.Key, returnVisitorCookie.Ordered) === "true");
		const genericSubscriptionId = form.getAttribute("data-sub-generic");

		if (hasOrdered === true && typeof genericSubscriptionId !== "undefined" && genericSubscriptionId !== "")
		{
			this.MakeFormGeneric(form, genericSubscriptionId);
		}
	};

	public MakeFormGeneric = (frmSubscribe: HTMLFormElement, genericSubscriptionId: string): void =>
	{
		const subscribeOffer = frmSubscribe.querySelector(".subscribe__offer");
		const subscribeText = frmSubscribe.querySelector(".subscribe__text");
		const subscribeThanks = frmSubscribe.querySelector(".subscribe__thx");
		const subscribeSent = frmSubscribe.querySelector(".subscribe__sent");

		frmSubscribe.setAttribute("data-sub", genericSubscriptionId);
		subscribeOffer.classList.add("subscribe__offer--generic");
		subscribeThanks.classList.add("subscribe__thx--generic");
		subscribeText.innerHTML = this.GenericText;
		subscribeSent.innerHTML = this.GenericThanks;
	};

	public Submit = (form: HTMLFormElement, showBanner = true, event?: Event): boolean =>
	{
		if (typeof event !== "undefined")
		{
			event.preventDefault();
		}

		// Reset phone input to empty string if the signup checkbox isn't selected
		const phoneCheck: HTMLInputElement = form.querySelector("#chkPhone");
		const phoneInput: HTMLInputElement = form.querySelector("input[type=tel]");

		if (phoneCheck !== null && phoneInput !== null && !phoneCheck.checked)
		{
			phoneInput.value = "";
		}

		const emailInput: HTMLInputElement = form.querySelector("input[type=email]");
		const email = emailInput !== null ? emailInput.value : "";
		const isEmailValid = Validation.Email(email);
		const phone = phoneInput !== null ? phoneInput.value : "";
		const subscriptionId = form.getAttribute("data-sub");
		let errors = "";

		if (isEmailValid === false)
		{
			errors += TextResource.GetTextByCulture("Feature_Shipping_ValidEmail");
		}

		const alert = form.querySelector(".alert");

		if (errors.length > 0)
		{
			if (alert === null)
			{
				const alertNode = document.createElement("div");
				alertNode.innerHTML = `<div class="alert alert-danger" role="alert">${errors}</div>`;

				form.prepend(alertNode.firstChild);
			}
			else
			{
				alert.innerHTML = errors;
			}

			return false;
		}
		else
		{
			if (alert !== null)
			{
				alert.remove();
			}
		}

		this.engagementProvider.AddSubscription(phone, email, subscriptionId);
		this.engagementProvider.CreateGuestAccount(email, phone, isEmailValid, phone !== "");

		const offer: HTMLElement = form.querySelector(".subscribe__offer");
		const thanks: HTMLElement = form.querySelector(".subscribe__thx");
		const address: HTMLElement = form.querySelector(".subscribe__address");

		offer.style.display = "none";
		thanks.style.display = "block";
		address.textContent = email;

		return false;
	};

	public UpdateFooter = (): void =>
	{
		const subscriptionService = new SubscriptionService();
		subscriptionService.GetFooter()
			.then((response: AxiosResponse) =>
			{
				const footerHtml = response.data;

				if (footerHtml !== "")
				{
					const footer = document.querySelector("#footer-subscribe");

					if (footer !== null)
					{
						footer.outerHTML = footerHtml;
						const frmSubscribe = document.querySelector("#frmSubscribe") as HTMLFormElement;

						if (frmSubscribe !== null)
						{
							const showPhone = frmSubscribe.getAttribute("data-show-phone");

							if (showPhone !== null && showPhone === "true")
							{
								this.MaskPhoneInput(frmSubscribe);
							}
						}
					}
				}
			})
			.catch((error) =>
			{
				console.log(error);
			});
	};
}